import PurchaseTools from '../Components/Purchase/PurchaseTools';

export default function PurchaseToolsPage() {
  return <PurchaseTools />;
}
